import api from '../../api.js';

export const TagSelector = {
  TAG_PRESSABLE: `${api.internals.ns.selector('tag')}[aria-pressed]`
};
